import React from 'react';

const contentContext = React.createContext({
  content: null,
  setContent: () => { throw Error('Notice context not initialized.'); },
  reloadContent: async () => { throw Error('Notice context not initialized.'); },
});

export { contentContext };
